import React, { useEffect } from "react";
import {
    Route,
    Switch,
    Link,
    useRouteMatch,
} from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { createLectureAPI, fetchAllLecturesAPI, deleteLectureAPI } from "views/APIs/APIUtility";
import SearchBar from "material-ui-search-bar";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/Delete";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

// @material-ui/icons
// import ContentCopy from "@material-ui/icons/ContentCopy";
import {
    Dialog,
    TextField,
    DialogActions,
    DialogContent,
    DialogTitle,
    CircularProgress,
    Tooltip,
    Typography,
    Divider,
    Box,
} from "@material-ui/core";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationContext from "views/Components/Context.js";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import Heading from "components/Heading/Heading";
import { CloudUpload, Create, DoneAll } from "@material-ui/icons";
import CreateCourseCard from "views/Components/CreateCourseCard";

import { DropzoneArea } from 'material-ui-dropzone';
import MDEditor from '@uiw/react-md-editor';
import { isConstructorDeclaration } from "typescript";
import MarkdownEditorWithPreview from "components/MarkdownEditor/MarkdownEditorWithPreview";

const useStyles = makeStyles(styles);
const usesweetAlertStyle = makeStyles(sweetAlertStyle);
const usedashboardStyle = makeStyles(dashboardStyle);


export default function LectureDesign() {
    const images = require.context("assets/img", true);

    // state variables
    const [alert, setAlert] = React.useState(null);
    const { path, url } = useRouteMatch();

    const [modal, setModal] = React.useState(false);
    const [name, setName] = React.useState('');
    const [brief, setBrief] = React.useState('');
    const [iconImage, setIconImage] = React.useState();
    const [searchValue, setSearchValue] = React.useState("");
    const [allLectures, setAllLectures] = React.useState([]);
    const [initialCourses, setInitialCourses] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [currentDialog, setCurrentDialog] = React.useState("Create Module");
    const [template, setTemplate] = React.useState("# Instructions\n- Number of modules: 5\n- Course requirements: Create an engaging and comprehensive course outline that contains 5 modules.\n- Module structure:\n  - Description: Provide a brief summary of each module that encapsulates the main topics and key takeaways.\n  - Learning objectives: Include a list of specific, actionable objectives for each module. Clearly outline what learners will gain or accomplish by completing the module.\n- Objective focus: Ensure that learning objectives are concise, measurable, and relevant to the overall course content.");
    const [courseOutline, setCourseOutline] = React.useState("# Module 1: **On Machine Learning Applications in Investments**\n**Description**: This module provides an overview of the use of machine learning (ML) in investment practices, including its potential benefits and common challenges. It highlights examples where ML techniques have outperformed traditional investment models.\n\n**Learning Outcomes**:\n- Understand the motivations behind using ML in investment strategies.\n- Recognize the challenges and solutions in applying ML to finance.\n- Explore practical applications of ML for predicting equity returns and corporate performance.\n### Module 2: **Alternative Data and AI in Investment Research**\n**Description**: This module explores how alternative data sources combined with AI are transforming investment research by providing unique insights and augmenting traditional methods.\n\n**Learning Outcomes**:\n- Identify key sources of alternative data and their relevance in investment research.\n- Understand how AI can process and derive actionable insights from alternative data.\n- Analyze real-world use cases showcasing the impact of AI in research and decision-making.\n### Module 3: **Data Science for Active and Long-Term Fundamental Investing**\n**Description**: This module covers the integration of data science into long-term fundamental investing, discussing how quantitative analysis can enhance traditional methods.\n\n**Learning Outcomes**:\n- Learn the foundational role of data science in long-term investment strategies.\n- Understand the benefits of combining data science with active investing.\n- Evaluate case studies on the effective use of data science to support investment decisions.\n### Module 4: **Unlocking Insights and Opportunities**\n**Description**: This module focuses on techniques and strategies for using data-driven insights to identify market opportunities and enhance investment management processes.\n\n**Learning Outcomes**:\n- Grasp the importance of leveraging advanced data analytics for opportunity identification.\n- Understand how to apply insights derived from data to optimize investment outcomes.\n- Explore tools and methodologies that facilitate the unlocking of valuable investment insights.\n### Module 5: **Advances in Natural Language Understanding for Investment Management**\n**Description**: This module highlights the progression of natural language understanding (NLU) and its application in finance. It covers recent developments and their implications for asset management.\n\n**Learning Outcomes**:\n- Recognize advancements in NLU and their integration into investment strategies.\n- Explore trends and applications of NLU in financial data analysis.\n- Understand the technical challenges and solutions associated with implementing NLU tools.\n###");
    const [uploadedFiles, setUploadedFiles] = React.useState([]);
    // const dialogStages = ["Create Course", "Upload", "Select Template", "Update Outline", "Submit", "Creating Course"];
    const dialogStages = ["Create Module"];
    const { showNotification } = React.useContext(NotificationContext);
    const [lectureCreationLoader, setLectureCreationLoader] = React.useState(false);

    // classes and styles
    const dashboardClasses = usedashboardStyle();
    const classes = useStyles();
    const sweetAlertClasses = usesweetAlertStyle();

    const handleIconUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setIconImage(file);
        }
    };


    const handleDeleteLecture = async (lectureData) => {
        const formData = new FormData();
        formData.append("lecture_id", lectureData._id);

        try {
            const data = await deleteLectureAPI(formData);
            setAllLectures(allLectures.filter((course) => course._id !== lectureData._id));
        }
        catch (error) {
            showNotification(error, "danger");
        }
        finally {
            hideAlert();
        }
    }

    const handleCloneCourse = (courseData) => {
        const formData = new FormData();
        formData.append("course_id", courseData._id);

        fetch(process.env.REACT_APP_FASTAPI_URL + "/clone_course",
            {
                method: "POST",
                body: formData,
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setAllLectures([...allLectures, data]);
            })
            .catch((error) => {
                showNotification(error, "danger");
            })
            .finally(() => {
            });
        hideAlert();
    }

    const deleteAlert = (lectureData) => {
        setAlert(
            <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Are you sure?"
                onConfirm={() => handleDeleteLecture(lectureData)}
                onCancel={() => hideAlert()}
                confirmBtnCssClass={
                    sweetAlertClasses.button + " " + sweetAlertClasses.success
                }
                cancelBtnCssClass={
                    sweetAlertClasses.button + " " + sweetAlertClasses.danger
                }
                confirmBtnText="Yes, delete it!"
                cancelBtnText="Cancel"
                showCancel
            >
                This action will permanantly delete the module and will not be recoverable.
            </SweetAlert>
        );
    };

    const cloneAlert = (courseData) => {
        setAlert(
            <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Are you sure?"
                onConfirm={() => handleCloneCourse(courseData)}
                onCancel={() => hideAlert()}
                confirmBtnCssClass={
                    sweetAlertClasses.button + " " + sweetAlertClasses.success
                }
                cancelBtnCssClass={
                    sweetAlertClasses.button + " " + sweetAlertClasses.danger
                }
                confirmBtnText="Yes, clone it!"
                cancelBtnText="Cancel"
                showCancel
            >
                This action will create a clone of the current module.
            </SweetAlert>
        );
    };


    useEffect(() => {
        const fetchData = async () => {
            // Fetch all lectures
            try {
                const data = await fetchAllLecturesAPI();
                setAllLectures(data);
                setInitialCourses(data);
            } catch (error) {
                showNotification(error, "danger");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const [courseOutlineLoader, setCourseOutlineLoader] = React.useState(false);

    const generateCourseOutline = () => {
        setCourseOutlineLoader(true);
        const formData = new FormData();
        uploadedFiles.forEach((file) => {
            formData.append("files", file);
        });
        formData.append("instructions", template);


        fetch(process.env.REACT_APP_FASTAPI_URL + "/generate_course_outline",
            {
                method: "POST",
                body: formData,
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setCourseOutline(data);
                setCourseOutlineLoader(false);
            })
            .catch((error) => {
                showNotification(error, "danger");
                setCourseOutlineLoader(false);
            });
    }

    async function fetchImageAsFile(imageUrl) {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const file = new File([blob], "qcreate_logo.png", { type: blob.type });
        return file;
    }

    const handleCreateLecture = async () => {
        setLectureCreationLoader(true);
        const imageToUse = iconImage || await fetchImageAsFile(images("./qcreate_logo.png"));
        const formData = new FormData();
        formData.append("lecture_name", name);
        formData.append("lecture_description", brief);
        formData.append("lecture_outline", courseOutline);
        uploadedFiles.forEach((file) => {
            formData.append("files", file);
        });
        formData.append("lecture_image", imageToUse);

        try {
            const data = await createLectureAPI(formData);
            setAllLectures([...allLectures, data]);
            showNotification("Module created successfully", "success");
            setLectureCreationLoader(false);
        }
        catch (error) {
            showNotification(error, "danger");
            setLectureCreationLoader(false);
        }
        finally {
            handleClose();
        }
    }

    const hideAlert = () => {
        setAlert(null);
    };

    const createCourse = () => {
        setModal(true);
    };

    const clearCreateModal = () => {
        setName('');
        setBrief('');
        setIconImage(null);
        setUploadedFiles([]);
    };

    const handleClose = () => {
        setCurrentDialog("Create Module");
        setModal(false);
        clearCreateModal();
    };

    const searchInputValue = (e) => {
        setSearchValue(e);
        if (e.length === 0) {
            setAllLectures(initialCourses); // Restore from initial courses
            return;
        }
        const newList = initialCourses.filter(
            (course) =>
                (course.course_name && course.course_name.toLowerCase().includes(e.toLowerCase())) ||
                (course.course_description &&
                    course.course_description.toLowerCase().includes(e.toLowerCase()))
        );
        setAllLectures(newList);
    };

    const handleFileUpload = (files) => {
        setUploadedFiles(files);
    };

    const [buttonAction, setButtonAction] = React.useState(null);

    // handle next actions on dialogs
    const handleStep1 = () => {
        if (name === "" || !iconImage) {
            showNotification("Please fill in all the fields", "danger");
            return;
        }
        // setCurrentDialog(dialogStages[dialogStages.indexOf(currentDialog) + 1]);
        // handleCreateLecture();
    }

    const handleStep2 = () => {
        if (uploadedFiles.length === 0) {
            showNotification("Please upload files", "danger");
            return;
        }
        setCurrentDialog(dialogStages[dialogStages.indexOf(currentDialog) + 1]);
    }

    const handleStep3 = () => {
        if (template === "") {
            showNotification("Please fill in the instructions", "danger");
            return;
        }
        generateCourseOutline();
        setCurrentDialog(dialogStages[dialogStages.indexOf(currentDialog) + 1]);
    }

    const handleStep4 = () => {
        if (courseOutline === "") {
            showNotification("Please fill in the module outline", "danger");
            return;
        }
        setCurrentDialog(dialogStages[dialogStages.indexOf(currentDialog) + 1]);
    }

    const handleStep5 = () => {
        // setCurrentDialog(dialogStages[dialogStages.indexOf(currentDialog) + 1]);
        handleCreateLecture();
    }



    const renderDialogContent = () => {
        switch (currentDialog) {
            case "Create Module":
                return (
                    <div>
                        <Typography variant="h5" style={{
                            marginBottom: "10px"
                        }}>Enter the Module details:</Typography>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Module Name"
                            type="text"
                            fullWidth
                            required
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                        />
                        <TextField
                            margin="dense"
                            id="brief"
                            label="Brief Description"
                            type="text"
                            fullWidth
                            multiline
                            required
                            rows={3}
                            value={brief}
                            onChange={(event) => setBrief(event.target.value)}
                        />
                        {/* Icon Image Upload */}
                        <Button
                            variant="contained"
                            component="label"
                            color="info"
                            style={{ marginTop: '20px' }}
                        >
                            <CloudUpload /> &nbsp; Upload Image
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                required
                                onChange={handleIconUpload}
                            />
                        </Button>
                        {iconImage && (
                            <div style={{ marginTop: '10px' }}>
                                <strong>Uploaded Image:</strong> {iconImage.name}
                            </div>
                        )}
                        <Typography variant="caption" style={{ display: "block", marginTop: "5px" }}>
                            A 16:9 aspect ratio image is recommended
                        </Typography>
                    </div>
                );
            case "Upload":
                return (
                    <div>
                        <Typography variant="h5" style={{
                            marginBottom: "10px"
                        }}>Upload your files:</Typography>
                        <DropzoneArea
                            initialFiles={uploadedFiles}
                            onChange={handleFileUpload}
                            showPreviews={true}
                            showPreviewsInDropzone={false}
                            maxFileSize={50000000}
                            dropzoneText="Drag and drop or click here to upload files."
                            useChipsForPreview
                            acceptedFiles={["application/pdf"]}
                            previewText="Uploaded files"
                            filesLimit={100}
                            style={{
                                padding: "10px",
                                minHeight: "200px",
                                minWidth: "200px",
                            }}
                        />
                    </div>

                );
            case "Select Template":
                return (
                    <div>
                        <Typography variant="h5" style={{
                            marginBottom: "10px"
                        }}>Edit the following instructions to create the module or add your own:</Typography>
                        <div data-color-mode="light">

                            <MarkdownEditorWithPreview
                                value={template}
                                onChange={(e) => setTemplate(e)}
                                height={400}
                            />
                        </div>
                    </div>
                );
            case "Update Outline":
                return (
                    <div>
                        <Typography variant="h5" style={{
                            marginBottom: "10px"
                        }}>Module outline:</Typography>
                        {courseOutlineLoader ? <div style={{
                            display: "flex"
                        }}>
                            <CircularProgress size={20} /> &nbsp;
                            <Typography variant="body1">Generating module outline...</Typography>
                        </div> :
                            <div data-color-mode="light">

                                <MarkdownEditorWithPreview
                                    value={courseOutline}
                                    onChange={(e) => setCourseOutline(e)}
                                    height={400}
                                />
                            </div>}
                    </div>
                );
            case "Submit":
                return (
                    <div>
                        <Typography variant="h5" style={{
                            marginBottom: "10px"
                        }}>Here's the summary of the module that will be created for you:</Typography>
                        <Card style={{ padding: "10px", margin: "10px", height: "20vh", overflowY: "auto" }}>
                            <Typography variant="h5">Summary:</Typography>
                            <Divider />
                            <Typography variant="body1"><b>Module Name:</b> {name}</Typography>
                            <Typography variant="body1"><b>Brief Description:</b> {brief}</Typography>
                            <Typography variant="body1"><b>Icon Image:</b> {iconImage ? iconImage.name : "Not uploaded"}</Typography>
                        </Card>
                        <Card style={{ padding: "10px", margin: "10px", height: "30vh", overflowY: "scroll" }}>
                            <Typography variant="h5">Module Outline:</Typography>
                            <Divider />
                            <div data-color-mode="light">

                                <MarkdownEditorWithPreview
                                value={courseOutline}
                                disabled={true}
                                />
                            </div>
                        </Card>

                    </div>
                );
            case "Creating Module":
                return (
                    <div style={{
                        display: "flex"
                    }}>
                        <CircularProgress size={20} /> &nbsp;
                        <Typography variant="body1">Creating module for you...</Typography>
                    </div>
                );

            default:
                return null;
        }
    };


    const getStatusIcon = (status) => {
        switch (status) {
            case "In Design Phase":
                return (<Create style={{ color: "#435966" }} />)
            case "Ready for Publishing":
                return (<CloudUpload style={{ color: "#435966" }} />)
            case "Published":
                return (<DoneAll style={{ color: "#435966" }} />);
            default:
                return null;

        }
    }

    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="60vh"
            >
                <CircularProgress color="quCreateColor" />
                <Typography variant="h6" style={{ marginLeft: 16, textTransform: 'none' }}>
                    Loading Modules...
                </Typography>
            </Box>
        );
    }

    return (
        <div>
            {alert}

            {/* Dialog Box for Adding new course */}

            <Dialog open={modal} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="md" fullWidth>
                <DialogTitle id="form-dialog-title">
                    <div style={{ fontSize: '30px' }}>Create New Module</div>
                </DialogTitle>
                <DialogContent>
                    {renderDialogContent()}
                </DialogContent>
                <DialogActions>
                    {
                        // currentDialog !== "Create Lecture" && (
                        //     <Button
                        //         onClick={() => setCurrentDialog(dialogStages[dialogStages.indexOf(currentDialog) - 1])}
                        //         color="quCreateColor"
                        //         disabled={courseOutlineLoader || lectureCreationLoader}
                        //     >
                        //         Back
                        //     </Button>
                        // )
                    }
                    <Button onClick={handleClose} color="quCreateColor" disabled={courseOutlineLoader || lectureCreationLoader}>Cancel</Button>
                    <Button
                        // onClick={() => {
                        //     switch (currentDialog) {
                        //         case "Create Lecture":
                        //             return handleStep1();
                        //         case "Upload":
                        //             return handleStep2();
                        //         case "Select Template":
                        //             return handleStep3();
                        //         case "Update Outline":
                        //             return handleStep4();
                        //         case "Submit":
                        //             return handleStep5();
                        //         default:
                        //             return null;
                        //     }
                        // }
                        // }
                        onClick={handleCreateLecture}
                        disabled={courseOutlineLoader || lectureCreationLoader}
                        color="quCreateColor"
                    >
                        {/* {currentDialog === "Submit" ? "Submit" : "Next"} */}
                        {currentDialog === "Create Module" ? "Submit" : "Next"}
                    </Button>

                </DialogActions>
            </Dialog>


            {/* Actual Page starts here */}
            <Switch>
                <Route exact path={path}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12} lg={12}>
                            <SearchBar
                                value={searchValue}
                                onChange={(newValue) => searchInputValue(newValue)}
                                onRequestSearch={(newValue) => searchInputValue(newValue)}
                            />
                        </GridItem>
                        {/* <GridItem
                            xs={12}
                            sm={4}
                            md={4}
                            lg={2}
                            style={{ textAlign: "center" }}
                        >
                            <Button color="quCreateColor" fullWidth onClick={() => setModal(true)}>
                                Create Module
                            </Button>
                        </GridItem> */}
                    </GridContainer>
                    <GridContainer>
                        {allLectures.length === 0 &&
                            <GridItem xs={12} sm={12} md={12} lg={12} style={{
                                marginTop: "20px",
                            }}>
                                <Box display="flex" justifyContent="center" >
                                    <Typography variant="h5" textAlign="center">
                                        Create or Review your Lectures to get started.
                                    </Typography>
                                </Box>
                                {/* <Typography variant="h5">No modules found. Create a new module to get started.</Typography> */}
                            </GridItem>
                        }

                        {allLectures.map((lecture, index) => (
                            <GridItem key={index} xs={12} sm={6} md={6} lg={4}>
                                <Link
                                    to={{
                                        pathname: `${url}/${lecture._id}`,
                                        state: { project_name: lecture.lecture_name },
                                        // pathname: path + "/lecture/" + lecture._id,
                                    }}
                                >
                                    <Card style={{ minHeight: "245px", maxHeight: "245px", marginTop: "40px" }}>
                                        <CardHeader stats icon>
                                            <CardIcon color="quCreateColor">
                                                {lecture.lecture_name}
                                            </CardIcon>
                                            <h3 className={classes.cardTitle} style={{
                                                zIndex: 100,
                                            }}>
                                                <small>
                                                    <img
                                                        // src={images("./qusandbox_logo_v2.5.png")}
                                                        src={lecture.lecture_image}
                                                        alt=""
                                                        className={classes.thumbnail}

                                                    />
                                                </small>
                                            </h3>
                                        </CardHeader>
                                        <CardBody style={{ paddingTop: "0px", paddingBottom: "0px" }} />
                                        <CardFooter>
                                            <Tooltip
                                                id="tooltip-top"
                                                title={lecture.lecture_description}
                                                placement="bottom"
                                                classes={{ tooltip: dashboardClasses.tooltip }}
                                            >
                                                <h5
                                                    style={{
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textOverflow: "ellipsis",
                                                        width: "100%",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    {lecture.lecture_description
                                                        .split(" ")
                                                        .slice(0, 10)
                                                        .join(" ") + (lecture.lecture_description.split(" ").length > 10 ? "..." : "")}
                                                </h5>
                                            </Tooltip>
                                        </CardFooter>
                                        <CardFooter stats style={{ marginTop: "0px", paddingBottom: "10px" }}>
                                            <div style={{
                                                display: "flex",
                                                width: "100%",
                                                justifyContent: "space-between",
                                            }}>
                                                {/* <FileCopyIcon
                                                        style={{ color: "#435966" }}
                                                        onClick={(e) => e.preventDefault(cloneAlert(course))}
                                                    /> */}
                                                <p>
                                                    {getStatusIcon(lecture.status)} &nbsp;
                                                    {lecture.status}
                                                </p>
                                                <DeleteIcon
                                                    style={{
                                                        color: "#435966",
                                                    }}
                                                    onClick={(e) => e.preventDefault(deleteAlert(lecture))}
                                                />
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </Link>
                            </GridItem>
                        ))}
                        <GridItem xs={12} sm={6} md={6} lg={4}>

                            <CreateCourseCard onClick={() => setModal(true)} />

                        </GridItem>
                    </GridContainer>
                </Route>
            </Switch>

        </div >
    );
}